var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 109 124",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.7 23.7s-1.4.4-3.6 1.1c-.4-1.2-1-2.6-1.7-4-2.4-4.6-5.9-7-10.1-7h-1c-.1-.2-.2-.3-.3-.4-1.9-2-4.3-2.9-7.2-2.8-5.6.2-11.2 4.2-15.7 11.5-3.2 5.1-5.6 11.5-6.3 16.5-6.4 2-10.9 3.4-11 3.4-3.3 1-3.4 1.1-3.8 4.2-.3 2.3-9 69.3-9 69.3l72.7 12.5 31.5-7.8s-13.4-90.2-13.5-90.8c-.1-.6-.6-1-1.1-1l-.9.3zm-8.7 2.7c-1.5.5-3.2 1-5 1.6-.1-2.6-.5-6.2-1.5-9.2 3.5.6 5.2 4.6 6.5 7.6zm-8 2.5c-3.3 1-7 2.2-10.7 3.4 1-4 3-8 5.4-10.7 1-1 2.3-2.1 3.8-2.7 1.6 2.9 1.9 7.1 1.5 10zm-7.5-14.4c1.3 0 2.4.3 3.3.9-1.5.8-3 1.9-4.4 3.4-3.2 3.4-5.6 8.8-6.6 14-3 .9-6 1.9-8.7 2.7 1.9-8.7 9.2-20.7 16.4-21z",
    fill: "#95BF47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6 24.4l-.9.3s-1.4.4-3.6 1.1c-.4-1.2-1-2.6-1.7-4-2.4-4.6-5.9-7-10.1-7h-1l-.3-.4c-1.9-2-4.3-2.9-7.2-2.8l-3.1 109.5 31.5-7.8s-13.4-90.2-13.5-90.8c-.1-.6-.6-1-1.1-1z",
    fill: "#5E8E3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6 41.2l-3.6 13.8s-4.1-1.9-9-1.6c-7.2.5-7.3 5-7.2 6.2.4 6.1 16.6 7.5 17.5 22 .7 11.4-6 19.2-15.7 19.8-11.7.7-18.1-6.2-18.1-6.2l2.5-10.6s6.5 4.9 11.7 4.6c3.4-.2 4.6-3 4.5-5-.5-8-13.7-7.5-14.5-20.8-.7-11.2 6.6-22.5 24.7-23.6 6.2-.3 7.2 1.4 7.2 1.4z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopify);
export default __webpack_public_path__ + "static/media/shopify.9876ba335eb603b0b45e27df51423080.svg";
export { ForwardRef as ReactComponent };